<div class="upload-file-wrapper po-upload-card">
  <header class="card-head">
    <div class="text">
      <h2>Upload Pure Original File</h2>
      <p>Pair BIN and INI, add WinOls, then upload.</p>
    </div>
    <div class="card-head-actions">
      <span class="ready-pill"><span class="dot"></span> READY</span>
      <button type="button" class="po-refresh-btn" (click)="refreshUpload()" aria-label="Reset upload fields">
        <i class="bi bi-arrow-clockwise"></i>
      </button>
    </div>
  </header>

  <div class="po-card-body">
    <div class="first-row">
      <div class="input-container">
        <app-upload-file
          inputText="Drag &amp; Drop BIN"
          [matchTuneVisual]="true"
          (file)="uploadBin($event)"
          [error]="pureOriginalsUploadService.myInputs.get('bin').message"
          [resetSignal]="pureOriginalsUploadService.resetSignal()"
          customBackground="transparent"
        ></app-upload-file>
      </div>
      <div class="input-container">
        <app-upload-file
          inputText="Drag &amp; Drop INI"
          [matchTuneVisual]="true"
          (file)="uploadIni($event)"
          [error]="pureOriginalsUploadService.myInputs.get('ini').message"
          [resetSignal]="pureOriginalsUploadService.resetSignal()"
          customBackground="transparent"
        ></app-upload-file>
      </div>
    </div>

    <div class="second-row">
      <div class="add-bar-container">
        <input
          type="text"
          placeholder="Add WinOls"
          name="winOlsValue"
          [formControl]="pureOriginalsUploadService.winOls"
          (keyup.enter)="uploadAllFiles()"
        />
        <div class="error-message-container">
          <span *ngIf="pureOriginalsUploadService.winOls.hasError('olsFormat')" class="error-upload-message">
            WinOls has to end with '.ols'.
          </span>
          <span *ngIf="pureOriginalsUploadService.myInputs.get('winOls').hasError" class="error-upload-message">
            {{ pureOriginalsUploadService.myInputs.get('winOls').message }}
            <a
              *ngIf="pureOriginalsUploadService.myInputs.get('winOls').pureOriginalId"
              [href]="'/app/pure-originals/pure-original-details?pureOriginalId=' + pureOriginalsUploadService.myInputs.get('winOls').pureOriginalId"
              >View details</a
            >
          </span>
        </div>
      </div>
      <div class="button-wrapper">
        <div class="button-position">
          <button
            type="button"
            class="button dropzone po-submit-btn"
            (click)="uploadAllFiles()"
            [disabled]="
              pureOriginalsUploadService.hasAnyError() ||
              pureOriginalsUploadService.winOls.invalid ||
              pureOriginalsUploadService.isUploading() ||
              !pureOriginalsUploadService.binFile() ||
              !pureOriginalsUploadService.iniFile()
            "
            [ngClass]="pureOriginalsUploadService.hasAnyError() === true ? 'red' : ''"
          >
            <span class="button-text">Upload</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
